import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useDispatch, useSelector } from 'react-redux';
import { updateOptionConfirmDialog } from 'store/dialog/reducer';
import { Divider, Grid, Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CustomButton from 'components/CustomInput/Button';
import styled from 'styled-components';

const SContent = styled.div`
    min-width: 400px;
    font-weight: 500;
    display: flex;
`;

const OptionConfirmDialog = ({ type = '' }) => {
    const isShow = useSelector((state) => state.dialog.optionConfirmDialog.isShow);
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const [involveFlag, setInvolveFlag] = React.useState('');

    useEffect(() => {
        if (isShow) {
            setInvolveFlag('');
        }
    }, [isShow]);

    const handleOk = () => {
        dispatch(
            updateOptionConfirmDialog({
                result: true,
                involveFlag,
                // isShow: true,
            }),
        );
    };

    const handleCancel = async () => {
        const isConfirm = await showDialog({
            description: (
                <>
                    Site Info has <b>NOT YET</b> successfully submitted. Please ensure to read through the reminder and
                    indicate for Site Info submission.
                </>
            ),
            disableCancelButton: true,
        });
        dispatch(
            updateOptionConfirmDialog({
                result: false,
                involveFlag: undefined,
                // isShow: true,
            }),
        );
    };

    const handleChange = (value) => {
        setInvolveFlag(value);
    };

    return (
        <Dialog open={isShow} style={{ margin: 'auto' }} maxWidth={'lg'}>
            <DialogTitle style={{ fontWeight: 'bold', width: 800 }}>
                <div style={{ fontSize: 16, fontWeight: 600 }}>Reminders for Study Team</div>
                <Divider style={{ marginTop: '10px', backgroundColor: '#000 ' }} />
            </DialogTitle>

            <DialogContent style={{ width: 800 }}>
                <SContent>
                    <DialogContentText style={{ paddingTop: 2, fontWeight: 'normal' }}>
                        <Grid container>
                            <Grid item xs={12} style={{ marginBottom: '15px', color: '#0a0a0a' }}>
                                1.&emsp;The study team should refrain from engaging in any research activities that
                                could bring disrepute or embarrassment to the HA, or undermine the confidence of
                                patients and the general public.
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: '15px', color: '#0a0a0a' }}>
                                2.&emsp;When conducting studies that involve comparisons of data across different
                                hospitals or clusters, it is recommended to consult the respective hospital or cluster
                                management to ensure the accuracy and reliability of the data.
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: '15px', color: '#0a0a0a' }}>
                                3.&emsp;For studies involving novel treatments, advanced technologies, alternative
                                medicine, or cases that may attract media attention due to their unique or high-profile
                                nature, the study team is strongly advised to formally seek guidance and support from
                                the hospital or cluster management before the commencement of the study.
                            </Grid>
                            <Grid item xs={12} style={{ fontWeight: 600, color: '#000' }}>
                                I acknowledge that my study complies with the above requirements and does&emsp;
                                <FormGroup row style={{ display: 'inline' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={involveFlag === 'no'}
                                                onChange={() => handleChange('no')}
                                                name="notInvolve"
                                                color="primary"
                                                style={{ width: '10px', height: '10px', color: '#FFF' }}
                                            />
                                        }
                                        label="not involve"
                                        style={{
                                            marginRight: '0',
                                            backgroundColor: '#303f9f',
                                            color: '#FFF',
                                            borderRadius: '4px',
                                            padding: '3px 5px',
                                        }}
                                    />
                                    {/* <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={involveFlag === 'no'}
                                                onChange={() => handleChange('no')}
                                                name="involve"
                                                color="primary"
                                                style={{ width: '10px', height: '10px' }}
                                            />
                                        }
                                        label={
                                            <Grid
                                                style={{
                                                    background: '#303f9f',
                                                    borderRadius: '4px',
                                                    fontWeight: '600',
                                                    color: '#FFF',
                                                    padding: '3px 5px',
                                                }}
                                            >
                                                not involve
                                            </Grid>
                                        }
                                        style={{ marginRight: '0' }}
                                    /> */}
                                    &nbsp;/&emsp;
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={involveFlag === 'yes'}
                                                onChange={() => handleChange('yes')}
                                                name="involve"
                                                color="primary"
                                                style={{ width: '10px', height: '10px', color: '#FFF' }}
                                            />
                                        }
                                        label="involve"
                                        style={{
                                            marginRight: '0',
                                            backgroundColor: '#303f9f',
                                            color: '#FFF',
                                            borderRadius: '4px',
                                            padding: '3px 5px',
                                        }}
                                    />
                                </FormGroup>
                                &nbsp;novel treatments, advanced technologies, alternative medicine, or cases that may
                                attract media attention.
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </SContent>
            </DialogContent>
            <DialogActions style={{ padding: 15 }}>
                <CustomButton type={'cancel'} onClick={handleCancel}>
                    Close
                </CustomButton>

                <CustomButton onClick={handleOk} autoFocus disabled={!involveFlag}>
                    Confirm
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default OptionConfirmDialog;
